import request from '@/utils/request'

// export function getTransitionFeeSetting(page, limit) {
//   return request({
//     url: `/project_deliver/list?page=${page}&limit=${limit}`,
//     method: 'get',
//   })
// }
export function getTransitionFeeSetting(params) {
    return request({
      url: `/project_deliver/list`,
      method: 'get',
      params
    })
  }
export function putTransitionFeeSetting(data) {
    return request({
      url: `/project_deliver/put/${data.id}`,
      method: 'post',
      data
    })
}
export function addTransitionFeeSetting(data) {
    return request({
      url: `/project_deliver/add`,
      method: 'post',
      data
    })
}
  
export function delTransitionFeeSetting(id) {
    return request({
      url: `/project_deliver/del/${id}`,
      method: 'get',
    })
}
  